// extracted by mini-css-extract-plugin
export default {"container":"AvatarEdit_container__EXsBo","avatar":"AvatarEdit_avatar__j2eye","corner":"AvatarEdit_corner__vxgOL"};